import { Field } from 'react-final-form';
import { required } from '../../../helpers';
import { LoanType } from '../../../interfaces';
import FormError from '../../Common/FormError';

const LoanTypeComponent = () => {
  return (
    <div className='fv-row'>
      <div className='row'>
        <div className='col-lg-6'>
          <Field name='loan_type' type='radio' value={LoanType.MORTGAGE} validate={(v) => required(v, 'Loan type')}>
            {({ input, meta }) => (
              <>
                <input type='radio' {...input} name='loan_type' className='btn-check' value={LoanType.MORTGAGE} id={`kt_register_loan_type_${LoanType.MORTGAGE}`} />
                <FormError meta={meta} />
              </>
            )}
          </Field>
          <label className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center mb-5' htmlFor={`kt_register_loan_type_${LoanType.MORTGAGE}`}>
            {/* <img src={InvestorImage} className='svg-icon-3x me-5' alt='investor' style={{ width: '35px' }} /> */}

            <span className='d-block fw-bold text-start'>
              <span className='text-dark d-block fs-7 mb-2'>Mortgage</span>
              <span className='text-gray-400 fw-bold fs-8'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</span>
            </span>
          </label>
        </div>

        <div className='col-lg-6'>
          <Field name='loan_type' type='radio' value={LoanType.EQUITY_FINANCE} validate={(v) => required(v, 'Loan type')}>
            {({ input, meta }) => (
              <>
                <input type='radio' {...input} name='loan_type' className='btn-check' value={LoanType.EQUITY_FINANCE} id={`kt_register_loan_type_${LoanType.EQUITY_FINANCE}`} />
                <FormError meta={meta} />
              </>
            )}
          </Field>
          <label className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center mb-5' htmlFor={`kt_register_loan_type_${LoanType.EQUITY_FINANCE}`}>
            {/* <img src={BorrowerImage} className='svg-icon-3x me-5' alt='borrower' style={{ width: '35px' }} /> */}

            <span className='d-block fw-bold text-start'>
              <span className='text-dark d-block fs-7 mb-2'>Equity Financing</span>
              <span className='text-gray-400 fw-bold fs-8'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</span>
            </span>
          </label>
        </div>

        <div className='col-lg-6'>
          <Field name='loan_type' type='radio' value={LoanType.RENT} validate={(v) => required(v, 'Loan type')}>
            {({ input, meta }) => (
              <>
                <input type='radio' {...input} name='loan_type' className='btn-check' value={LoanType.RENT} id={`kt_register_loan_type_${LoanType.RENT}`} />
                <FormError meta={meta} />
              </>
            )}
          </Field>
          <label className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center mb-5' htmlFor={`kt_register_loan_type_${LoanType.RENT}`}>
            {/* <img src={ServiceProviderImage} className='svg-icon-3x me-5' alt='provider' style={{ width: '35px' }} /> */}

            <span className='d-block fw-bold text-start'>
              <span className='text-dark d-block fs-7 mb-2'>Rent</span>
              <span className='text-gray-400 fw-bold fs-8'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</span>
            </span>
          </label>
        </div>

        <div className='col-lg-6'>
          <Field name='loan_type' type='radio' value={LoanType.PAYDAY} validate={(v) => required(v, 'Loan type')}>
            {({ input, meta }) => (
              <>
                <input type='radio' {...input} name='loan_type' className='btn-check' value={LoanType.PAYDAY} id={`kt_register_loan_type_${LoanType.PAYDAY}`} />
                <FormError meta={meta} />
              </>
            )}
          </Field>
          <label className='btn btn-outline btn-outline-dashed btn-outline-default p-3 d-flex align-items-center mb-5' htmlFor={`kt_register_loan_type_${LoanType.PAYDAY}`}>
            {/* <img src={ServiceProviderImage} className='svg-icon-3x me-5' alt='provider' style={{ width: '35px' }} /> */}

            <span className='d-block fw-bold text-start'>
              <span className='text-dark d-block fs-7 mb-2'>Payday</span>
              <span className='text-gray-400 fw-bold fs-8'>Lorem Ipsum is simply dummy text of the printing and typesetting industry</span>
            </span>
          </label>
        </div>
      </div>
    </div>
  );
};

export default LoanTypeComponent;
